import ControlPanelAvatar from "./control-panel-avatar";

export default ControlPanelAvatar;